import React from "react";
import Sidebar from "../components/sidebar";
import Header from "../components/Header";
import AddLivecategory from "../components/Live/AddLiveCategory";

const AddLiveCategoryScreen = () => {
  return (
    <>
      <Sidebar />
      <main className="main-wrap">
        <Header />
        <AddLivecategory />
      </main>
    </>
  );
};

export default AddLiveCategoryScreen;
